module.exports = __webpack_public_path__ + "static/media/YM31_0.06f95716.jpg";